import { AfterViewInit, Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, UntypedFormGroup, Validators } from '@angular/forms';
import { config } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
import {TranslateService} from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core'
import { FormService } from '../../services/form.service';
import { AlphaService } from 'src/app/app-business-object-module/alpha.service';

@Component({
    selector: 'app-form-field-toggle-switch-v2',
    templateUrl: './form-field-toggle-switch-v2.component.html',
    styleUrls: ['./form-field-toggle-switch-v2.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldToggleSwitchV2Component implements OnInit, AfterViewInit, OnDestroy {

  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  toggleHintText:string;
  quotReqradioValue: string;
  disabled: boolean = false;
  userAccess;
  dynamicChecked: any;
  commonSiblingsSub : any;
  secondaryValue;
  dynamicHintToggle: boolean = false;
  intialBackedupData = [];
  private isIntialized = new WeakMap<AbstractControl,boolean>();
  templateData: any;
  constructor(private appService: AppService, public translate: TranslateService, private changeDetector: ChangeDetectorRef, private formServices :FormService, private alphaService:AlphaService) { }

  ngOnInit() {
    // below logic make sure the toggle to enable/disable and their hinttexts, when user switchs Include trade-in vehicle pickup
    this.formServices.tradeinMainToggleValue.subscribe((value: any) => {
      const flag = value && value.hasOwnProperty("flag") ? value.flag : value;
      let isCopyOrder = localStorage.getItem("isCopyOrder") || false;
      if(this.configData.name=='releaseAll' && !isCopyOrder){
        this.manageMultiAffectedColumn(flag,'')
      } else if (this.configData?.setValueOnToggleChange && !isCopyOrder) {
        this.manageMultiAffectedColumn(flag, value.id || "")
      }
    });

    if (this.frmGroup.get(this.configData.name).value === '' || this.frmGroup.get(this.configData.name).value === null || this.frmGroup.get(this.configData.name).value === undefined || this.frmGroup.get(this.configData.name).value === 'N') {
      if(this.configData.defaultValue === true) {
        this.frmGroup.get(this.configData.name).setValue(true);
      } else {
        this.frmGroup.get(this.configData.name).setValue(false);
      }
    } else if (this.frmGroup.get(this.configData.name).value.value) {
      this.frmGroup.get(this.configData.name).setValue(JSON.parse(this.frmGroup.get(this.configData.name).value?.value));
    } else{
      this.frmGroup.get(this.configData.name).setValue(JSON.parse(this.frmGroup.get(this.configData.name).value));
    }

    this.disabled = this.configData.disabled;
    if(this.disabled){
      this.frmGroup.get(this.configData.name).disable();
    } else {
      this.frmGroup.get(this.configData.name).enable();
    }
    // This should be remove when all featureNames get updated
    let menuPageAccess;
    if(this.configData["menuPageAccess"]){
      menuPageAccess = this.configData["menuPageAccess"];
    } else {
      menuPageAccess = this.configData["access"];
    }
    if (menuPageAccess) {
      this.userAccess = this.checkAccess(menuPageAccess);
    } else {
      this.userAccess = true;
    }
    //passing Object
    if (this.configData.dynamicVisibility) {
      if(this.configData.dynamicVisibility.action == 'hidden'){
        this.frmGroup.get(this.configData.name)['hidden'] = !this.checkAccess(this.configData.dynamicVisibility.featureName);
      }else
      if(this.configData.dynamicVisibility.action == 'disabled'){
        this.userAccess = this.checkAccess(this.configData.dynamicVisibility.featureName);
        if(this.checkAccess(this.configData.dynamicVisibility.featureName) == false){
          this.disabled = true;
        }
      }
    } else {
      this.userAccess = true;
    }

    // let cntrlName = this.configData.name;
    // if(this.frmGroup.controls[cntrlName].value === true || this.frmGroup.controls[cntrlName].value === false)
    // {
    //   this.configData.checked = this.frmGroup.controls[cntrlName].value;
    // }
    if (this.configData.validation)
      if (this.configData.validation.length)
        this.fieldValueValidation(this.configData.validation);
    //Set Default value for checkbox
    if (this.configData.hasOwnProperty('dynamicVisibility') && this.configData?.dynamicVisibility.hasOwnProperty('setValues')) {
      let setObj = this.configData.dynamicVisibility.setValues;
      let checkType = this.configData.dynamicVisibility;
      if (checkType && checkType?.valueType && checkType?.valueType === 'string') {
      let setObj = this.configData.dynamicVisibility.setValues;
      this.dynamicChecked = setObj.ngTrueValue == setObj.ngDefaultValue ? true : false;
      this.frmGroup.get(this.configData.name).setValue(setObj.ngDefaultValue);
      } else {
      const defaultValue = setObj.ngDefaultValue ?? setObj.ngFalseValue ?? 'N';
      let currentValue = this.frmGroup.get(this.configData.name).value;
      this.dynamicChecked = setObj.ngTrueValue == setObj.ngDefaultValue ? true : false;
      if (currentValue === true) {
        currentValue = setObj.ngTrueValue;
      } else if (currentValue === false) {
        currentValue = setObj.ngFalseValue;
      }
      this.dynamicChecked = currentValue === setObj.ngTrueValue;
      if (currentValue === undefined) {
        this.frmGroup.get(this.configData.name).setValue(defaultValue);
      }
    }
    } else {
      this.dynamicChecked = this.frmGroup.get(this.configData.name).value;
    }

    //CP-4385 - start
    if(this.configData['secondaryValue']){
      this.secondaryValue = this.frmGroup.get(this.configData['secondaryValue']).value;
      if(this.secondaryValue){
        this.secondaryValue= this.appService.getDifferenceBetweenDates(new Date(new Date(this.secondaryValue)+"UTC"), new Date(), false, true);
      }
    }//CP-4385 - end
    // To reset the toggle field value
    const h = v => {const r = this.templateData?.conditions?.find( x => x.type === 'ALLOW' && x.fields.includes(this.configData.name));
      if (r && !r.appliesTo.includes(v?.value || v) && this.frmGroup.get(this.configData.name)?.value !== true) {
        this.frmGroup.get(this.configData.name)?.setValue(r.resetValue, { emitEvent: false });
      }
      this.checkHint();
    };
    this.frmGroup.root.get('quoteType')?.valueChanges.subscribe(h);
    this.frmGroup.root.get('orderType')?.valueChanges.subscribe(h);
    this.frmGroup.root.get('orderSubType')?.valueChanges.subscribe(h);
  }
  checkMultipleItems(prop, action, setData) {
    for (const components in this.appService._components) {
      if (this.appService._components[components]?.configData?.component === "TABLE_V2") {
        this.appService._components[components]?.frmGroup.get(components)?.controls?.forEach(comp => {
          if (action === 'SHOW' && comp.controls[prop?.name]){
            comp.controls[prop?.name].hidden = false;
          } else if (action === 'HIDE' && comp.controls[prop?.name]) {
            comp.controls[prop?.name].hidden = true;
            comp.controls[prop?.name].reset();
            comp.controls[prop?.name].setValue('');
          } else if (action === 'NOT_REQUIRED' && comp.controls[prop?.name]) {
            comp.controls[prop.name].required = false;
            comp.controls[prop?.name].removeValidators([Validators.required]);
          } else if (action === 'REQUIRED' && comp.controls[prop?.name]) {
            comp.controls[prop.name].required = true;
            comp.controls[prop?.name].addValidators([Validators.required]);
          } else if (action === 'RESET' && comp.controls[prop?.name]) {
            comp.controls[prop?.name].reset();
            comp.controls[prop?.name].setValue('');
          } else if (action === 'SETDATA' && comp.controls[prop?.name]) {
            comp.controls[prop?.name].setValue(setData);
          } else if (action === 'DISABLED' && comp.controls[prop?.name]) {
            comp.controls[prop.name].disable = true;
            comp.controls[prop?.name].disable();
          } else if (action === 'ENABLED' && comp.controls[prop?.name]) {
            comp.controls[prop.name].disable = false;
            comp.controls[prop?.name].enable();
          }
          comp?.controls[prop?.name]?.updateValueAndValidity();
        })
        this.appService._components[components]?.configData?.controls?.forEach(comp => {
          if (action === 'REQUIRED' && comp.name === prop?.name){
            comp.required = true;
          } else if (action === 'NOT_REQUIRED' && comp.name === prop?.name){
            comp.required = false;
          } 
        })
      }
    }
  }
  fieldValueValidation(validations){
    validations.forEach((validataion:string | any) => {
      let element =  (typeof validataion == "object" ? validataion.name : validataion);
      if (element === 'hidden') {
        if (!(this.frmGroup.get(this.configData.name)['hidden'] === false)) {
          this.frmGroup.get(this.configData.name)['hidden'] = true;
          this.configData.required = false;
          this.frmGroup.get(this.configData.name).clearValidators();
          this.frmGroup.get(this.configData.name).updateValueAndValidity();
        }
      }

    });
  }

  manageMultiAffectedColumn(data, id) {
    if(this.configData['multiAffectedColumns']) {
      this.configData['multiAffectedColumns'].forEach(element => {
        let allZero = true;
        const toggleControl = this.frmGroup.get(this.configData.name);
        const storedData = localStorage.getItem('templatedata');
        const templateData = storedData ? JSON.parse(storedData) : null;
        const isConfirmed = templateData?.STATUS === 'SHIP_CONFIRMED';

        if (this.configData?.setValueOnToggleChange) {
          element.value.forEach(field => {
            const control = this.frmGroup.get(field.name);;
            if (control && Number(control.value) !== 0) {
              allZero = false;
            }
            if (toggleControl && !this.isIntialized.has(toggleControl)) {
              toggleControl.setValue(allZero, { emitEvent: false });
              this.isIntialized.set(toggleControl, true)
            }
          })
        }
        element.value.forEach(field => {
          if(this.configData.name=='releaseAll')
          {
            this.appService._components["poLines"].frmGroup.controls.poLines.controls.forEach(poLine =>  {
              if (field.action === "SETDATA" && data) {
                if (field?.otmKey) 
                {
                  poLine.controls[field.name].setValue(poLine.controls[field.otmKey].value);
                }
                else if(field?.defaultValue)
                {
                  poLine.controls[field.name].setValue(field.defaultValue);
                }
              }
              else
              {
                poLine.controls[field.name].setValue(field.defaultValue);
              }
            })
          }
          if (this.configData.name == 'zeroShip') {
            const orderLines = this.appService._components["orderLines"].frmGroup.controls.orderLines.controls;
            const lineItem = orderLines.find(line => line.controls.orderReleaseLineGid.value === this.frmGroup.controls.orderReleaseLineGid.value)
            if (this.frmGroup.controls.orderReleaseLineGid.value === id) {
              element.value.forEach(field => {
                const control = this.frmGroup.get(field.name);
                
                const toggleValue = toggleControl.value === true || toggleControl.value === 'Y';
                if (control && toggleControl) {
                  if (isConfirmed) {
                    setTimeout(() => {
                      toggleControl.disable({ emitEvent: false });
                      control.disable({ emitEvent: false });
                    }, 0);
                    return;
                  } else if (toggleValue) {
                    setTimeout(() => {
                      control.setValue(field.defaultValue ?? 0, { emitEvent: false });
                      control.disable({ emitEvent: false });
                    }, 0);
                  } else {
                      const lineData = this.intialBackedupData.find(s => s.orderReleaseLineGid === lineItem.controls.orderReleaseLineGid.value);
                      if (lineData && lineData.data && lineData.data[field.name]) {
                      setTimeout(() => {
                        control.setValue(lineData.data[field.name] ?? 0, { emitEvent: false });
                        control.enable({ emitEvent: false });
                      }, 0);
                    }
                  }
                }
              });
            }
          }
          this.frmGroup?.get(field.name)?.updateValueAndValidity();
        })
      })
    }
  }
  intializeBackUpData() {
    const orderLines = this.appService._components["orderLines"].frmGroup.controls.orderLines.controls;
    orderLines.forEach((line, idx) => {
      const toggleControl = line.get(this.configData.name);
      const isToggledOn = toggleControl?.value === true || toggleControl?.value === 'Y';
      if (!isToggledOn) {
      const lineItemBackUp = {};
      this.configData['multiAffectedColumns'].forEach(element => {
        element.value.forEach(field => {
          const control = line.get(field.name);
          if (control) {
            lineItemBackUp[field.name] = control.value;
          }
        });
      });
      this.intialBackedupData.push({
        orderReleaseLineGid: line.controls.orderReleaseLineGid.value,
        data: lineItemBackUp,
      })
    }
    });
    orderLines.forEach(line => {
      const toggleControl = line.get(this.configData.name);
      const isToggledOn = toggleControl?.value === true;
      if(!isToggledOn) {
        this.configData['multiAffectedColumns']?.[0]?.value.forEach (field => {
          const control = line.get(field.name);
          if (control) {
            control.enable({emitEvent: false});
          }
        })
      }
    })
  }

  toggleDisable(bool) {
    this.disabled = bool;
    if(this.disabled){
      this.frmGroup.get(this.configData.name).disable();
    } else {
      this.frmGroup.get(this.configData.name).enable();
    }
  }

  toggleVisibility(hidden) {
    this.configData.required = hidden ? !hidden : this.configData.required;
    this.frmGroup.get(this.configData.name)['hidden'] = hidden;
    if(hidden === true)
    this.frmGroup.get(this.configData.name).reset();
    if(this.configData.events && hidden === false)
    this.onCommonEventHander('TOGGLE', null);
    this.changeDetector.detectChanges();
    // if(this.configData.editAccess)
    // this.configData.editAccess.forEach(row=>{
    //   if(row.action == "hidden"){
    //     this.roleAccessValidation()
    //   }
    // })
  }

  checkFieldAccess(persona) {
    let role = localStorage.getItem('userRole');
    return persona.includes(role);
  }
  roleAccessValidation(){
    if (this.configData['editAccess']) {
        this.configData['editAccess'].forEach(row => {
            let persona;
            if (row.roleAccess) {
                persona = row.roleAccess;
            } else {
                persona = row.persona;
            }
            if (row.action == 'hidden') {
                this.frmGroup.get(this.configData.name)['hidden'] = !this.checkFieldAccess(persona);
            }
        });
    }
  }
  onReset(){
    if (this.frmGroup.get(this.configData.name) && this.frmGroup.get(this.configData.name)['hidden'] !== true && !(this.configData.validation && this.configData.validation.includes('hidden'))) {
      if (this.configData.hasOwnProperty('dynamicVisibility') && this.configData?.dynamicVisibility.hasOwnProperty('setValues')) {
        let currentValue = this.frmGroup.get(this.configData.name).value;
        let valueToBeSet;
        let setObj = this.configData.dynamicVisibility.setValues;
        if (currentValue === setObj.ngTrueValue || currentValue === setObj.ngFalseValue) {
          if (currentValue === 'Y') {
            valueToBeSet = true;
            this.dynamicChecked = true;
            this.frmGroup.get(this.configData.name).setValue(valueToBeSet, { emitEvent: true });
          } else if (currentValue === 'N') {
            valueToBeSet = false;
            this.dynamicChecked = false;
            this.frmGroup.get(this.configData.name).setValue(valueToBeSet, { emitEvent: true });
          }
        }
      }else{ 
        if(this.configData.disabled !== true && this.frmGroup.controls.dataUploadWrapper ) {
          this.frmGroup.get(this.configData.name).setValue(this.configData.defaultValue.value, { emitEvent: true });
        }
      }
      this.onCommonEventHander('TOGGLE', null);
    }
  }

  onCommonEventHander(eventType, eventFired) {
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    let allow = false;
    if(event){
      allow =  (event['eventOnDisable'] === true && this.disabled === true) || event['eventOnDisable'] === undefined;
    }
    if (this.frmGroup.get(this.configData.name).valid || allow) {
      if (event) {
        let flag: boolean = true;
        if(eventFired === 'INITIAL'){
          flag = event['stopInitialEvent'] === undefined || event['stopInitialEvent'] === false;
        }
        if(flag){
          if(event['eventOnDisable'] == undefined || this.disabled === false  || (event['eventOnDisable'] === true &&  this.disabled === true)){
            this.sendToSource(event, eventFired);
            return;
          }
        }
      }
    }
  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      if (event.length === 1) {
        event = event[0];
      } else if (event.length > 1) {
        event = event;
      } else { event = null }
    }
    return event;
  }

  sendToSource(event, userEvent) {
    if (this.configData.setValueOnToggleChange) {
      const id = this.frmGroup.controls.orderReleaseLineGid.value || '';
      const data = this.frmGroup.get(this.configData.name).value
      this.formServices.tradeinMainToggleSet({
        flag: data, 
        id: this.configData.name === 'zeroShip' ? id : ''
      });
    } else {
      const data = this.frmGroup.get(this.configData.name).value
      this.formServices.tradeinMainToggleSet(data);
    }
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.actionType || 'MULTIPLE_ACTION',
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: !(this.frmGroup.get(this.configData.name).value)
    }
    eventData['userEvent'] = userEvent;
    this.appService._commonComponentSubject.next(eventData);
  }

  checkAccess(access) {
    let menuPages = localStorage.getItem('menuPages');
    return menuPages.includes(access);

  }

  setValueToControl(value) {
    value = value == "" ? false : true;
    this.frmGroup.get(this.configData.name).setValue(value);
  }

  ngAfterViewInit() {
    if (this.frmGroup.get(this.configData.name)['hidden'] === false  || this.frmGroup.get(this.configData.name)['hidden'] == undefined) {
          setTimeout(() => {
            this.onCommonEventHander('TOGGLE', 'INITIAL');
          }, 1000)
          setTimeout(() => {
            localStorage.removeItem('isCopyOrder');
          }, 1200);
        }
        this.commonSiblingsSub = this.appService._valueTransferSub.subscribe(res => {
          let subObject = res.data;
          //console.log(res, "<====subject data changes");
          this.inputValueTypeFn(subObject);
        });
        if(this.configData.setValueOnToggleChange) {
          this.intializeBackUpData();
        }
      this.checkHint();
  }

  //Check value type and convert
  inputValueTypeFn = (value) => {
    if (value) {
      this.dynamicHintToggle = true
    } else {
      this.dynamicHintToggle = false
    }
    if (this.configData.hasOwnProperty('dynamicVisibility') && this.configData.dynamicVisibility.hasOwnProperty('setValues')) {
      let setObj = this.configData.dynamicVisibility.setValues;
      let setValue = value ? setObj.ngTrueValue : setObj.ngFalseValue;
      if(this.dynamicChecked != value){
        const control = this.frmGroup.get(this.configData.name);
        const groupValidationError = control?.errors?.groupValidationError;
        control.setValue(setValue, {emitEvent: false, onlySelf : true});
        if (groupValidationError) {
          control.setErrors({ groupValidationError: groupValidationError });
        }
        this.dynamicChecked = setValue == setObj.ngTrueValue ?  true :  false;
      }
    }
    else {
      this.dynamicChecked = this.frmGroup.get(this.configData.name).value;
    };
    console.log(this.frmGroup.get(this.configData.name).value, "<===data views and other")
    this.checkHint();
  }
  checkHint() {
    const root = this.frmGroup.root;
    const radioValue = root.get('quoteType')?.value?.value || root.get('quoteType')?.value;
    const orderTypeValue = root.get('orderType')?.value?.value || root.get('orderType')?.value;
    const orderSubTypeValue = root.get('orderSubType')?.value?.value || root.get('orderSubType')?.value;
    const selectedType = radioValue || orderTypeValue || orderSubTypeValue;
    const toggleValue = this.frmGroup.get(this.configData.name)?.value;

    if (!this.templateData) {
      this.templateData = this.appService.getcommonObject();
    }
    // Show Hint Text Conditions
    const hintConditions = this.templateData?.hintConditions || [];

    const match = hintConditions.find(hintRule =>
      hintRule.radio === selectedType &&
      hintRule.toggle === this.configData.name &&
      hintRule.value === toggleValue
    );

    this.toggleHintText = match ? match.message : '';
    this.configData.dynamictoggle = !!match;


    // Disable Button Conditions
    const conditions = this.templateData?.conditions || [];

    const getValue = (name) => this.appService._components[name]?.frmGroup?.get(name)?.value;

    let shouldDisable = false;

    conditions.forEach(rule => {
      if (rule.appliesTo && !rule.appliesTo.includes(selectedType)) {
        return;
      }
      let isMatched = false;

      if (rule.type === 'OR') {
        isMatched = rule.fields.some(field =>
          getValue(field) === rule.value
        );
      }

      if (rule.type === 'INVALID') {
        isMatched = rule.fields.some(field => {
          const val = getValue(field);
          return val === '' || val === false;
        });
      }

      if (isMatched) {
        shouldDisable = true;
      }

    });


    if (this.appService.formConfigData?.header?.action?.details?.[1]) {
      this.appService.formConfigData.header.action.details[1].disabled = shouldDisable;
    }

    }
  ngOnDestroy() {
    if (this.commonSiblingsSub) {
      this.commonSiblingsSub.unsubscribe();
    }
    localStorage.removeItem('isCopyOrder');
  }
}
